import FileManagement from '@components/file-management';
import SystemFilter from '@components/filters/system/manager';
import { ROUTES } from 'constants/routes';
import { systemManagerListColumns } from './list-data';
import { useEffect, useState } from 'react';
import { getSystemManagementList } from 'shared/helpers/system/get-system-management-list';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkPayloadObject } from 'shared/helpers/checkPayloadObject';

type ListData = {
  page: number;
  size: number;
  sortName: string;
  sortType: string;
  admSchGroup: 'sch_name' | 'sch_id' | 'sch_name_id' | '';
  schKeyword: string;
  schAdmSt: '10' | '20' | '30' | '50' | '';
  admList:
  | [
    {
      admEmail: string;
      admId: string;
      admName: string;
      admSeq: string;
      admSt: string;
      regDt: string;
    },
  ]
  | [];
  totalCount: number;
};

const ManagerPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isLoading, setLoading] = useState<boolean>(false)
  const initialData: ListData = {
    page: 1,
    size: 10,
    sortName: '',
    sortType: '',
    admSchGroup: '',
    schKeyword: '',
    schAdmSt: '',
    admList: [],
    totalCount: 0,
  }
  const [listData, setListData] = useState<ListData>(initialData);

  useEffect(() => {
    const isRefresh = location?.state?.refresh
    const fetchData = async () => {
      setLoading(true)
      await getSystemManagementList(initialData,
        // @ts-ignore
        [{ key: 'page', value: 1 }, { key: 'schKeyword', value: '' }, { key: 'schAdmSt', value: '', }, { key: 'admSchGroup', value: 'sch_name' }],
        setListData,
        ['page', 'schKeyword', 'schAdmSt', 'admSchGroup'])
      setLoading(false)
    }

    if (isRefresh) {
      fetchData()
    }
  }, [location?.state])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      await getSystemManagementList(listData, [], setListData, []);
      setLoading(false)
    }
    fetchData()
  }, []);

  return (
    <FileManagement
      isLoading={isLoading}
      title="관리자"
      isDialog={false}
      linkStack={[
        {
          label: 'Home',
          path: ROUTES.SYSTEM.MANAGER.path,
        },
        {
          label: '시스템',
          path: ROUTES.SYSTEM.MANAGER.path,
        },
        {
          label: '관리자',
          path: ROUTES.SYSTEM.MANAGER.path,
        },
      ]}
      Filter={
        <SystemFilter
          isLoading={isLoading}
          getFilteredList={async (payload) => {
            setLoading(true)
            await getSystemManagementList(listData, payload, setListData, [
              'page',
              'schAdmSt',
              'admSchGroup',
              'schKeyword',
            ]);
            if (!checkPayloadObject(payload)) {
              navigate(
                ROUTES.SYSTEM.MANAGER.path,
                { state: { page: payload[0].value, notEmpty: true } }
              )
            }
            setLoading(false)
          }}
        />
      }
      isCreateAction={false}
      listData={{
        columns: systemManagerListColumns,
        rows: listData?.admList?.map((item, index) => {
          return {
            id:
              listData.totalCount - (listData.page - 1) * listData.size - index,
            ...item,
          };
        }),
        totalCount: listData.totalCount,
        page: listData.page,
        pageSize: listData.size,
      }}
      getFilteredList={(payload) =>
        getSystemManagementList(listData, payload, setListData, [
          'sortName',
          'sortType',
        ])
      }
      handlePagination={async (payload) => {
        await getSystemManagementList(listData, payload, setListData, ['page'])
        if (!checkPayloadObject(payload)) {
          navigate(
            ROUTES.SYSTEM.MANAGER.path,
            { state: { page: payload[0].value, notEmpty: true } }
          )
        }
      }}
    />
  );
};

export default ManagerPage;
